import { slugify } from '@/utils/slugify';
import { trackCustomEvent } from '@/lib/appInsights';
import { TrackingCustomEvents } from '@/constants/constants';
import { useIsAuthenticated } from '@azure/msal-react';
import { useUser } from '@/state/UserContext';
import { useParams } from 'react-router-dom';

interface CategoryFilterButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  disabled?: boolean;
}

function CategoryFilterButton({ label, isActive, onClick, disabled }: CategoryFilterButtonProps) {
  const params = useParams();
  const { email, userId } = useUser();
  const isAuthenticated = useIsAuthenticated();

  function clickHander() {
    trackCustomEvent(TrackingCustomEvents.click.category.categoryFilter, {
      category: params.category ?? 'all',
      sub_category: params.subCategory ?? 'all',
      user_auth_status: isAuthenticated ? 'logged_in' : 'anonymous',
      user_email: email ?? 'anonymous',
      user_id: userId ?? 'anonymous',
    });
    onClick();
  }

  return (
    <li>
      <button
        disabled={disabled}
        onClick={clickHander}
        data-cy={`category-filter-button-${slugify(label)}`}
        className={`transition-all duration-400 ${isActive ? 'font-bold' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${!isActive && !disabled ? 'hover:text-teal-600' : ''}`}
      >
        {label}
      </button>
    </li>
  );
}

export default CategoryFilterButton;
